import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../services/base-service.service';
import { firstValueFrom } from 'rxjs';
import { Orgao } from './orgao.model';

@Injectable()
export class OrgaoService extends BaseService<Orgao, number> {

  constructor(
    http: HttpClient
  ) {
    super('orgao', http);
  }

  public recuperarSugestoesPorOrgaoId(orgaoId: number, termo: string): Promise<Orgao[]> {
    return firstValueFrom(this.http.get<Orgao[]>(this.path(`recuperarSugestoesPorOrgaoJusticaId/${orgaoId}?termo=${termo}`)));
  }
}
